import { render } from "./FeaturedProductCategoriesComponent.vue?vue&type=template&id=c1ecb00a"
import script from "./FeaturedProductCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedProductCategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/FeaturedProductCategoriesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1ecb00a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1ecb00a', __exports__)) {
    api.reload('c1ecb00a', __exports__)
  }
  
  module.hot.accept("./FeaturedProductCategoriesComponent.vue?vue&type=template&id=c1ecb00a", () => {
    api.rerender('c1ecb00a', render)
  })

}


export default __exports__